import React, { Component } from 'react'; 
import {Modal, FormControl, InputGroup, Button} from 'react-bootstrap';

import _ from 'lodash';

class AdditionalFields extends Component {
  constructor(props) {
    super(props)
      this.state = {
      Options:[],
      label: props.obj ? props.obj.labelObj :'',
      obj: props.obj
      }
  }
  componentDidMount()  {
    const{Options} = this.state;
    let x= {'label':''}
    Options.push(x)
    this.setState({Options})
  }
  addMoreOptions = () => {
    const{Options} = this.state
    Options.push({'label':''})
    this.setState({Options})
  }
  handleAddValues = () => {
    _.remove(this.state.Options, {label:""})
    this.props.addValues(this.state.obj, this.state.Options)
    this.props.closeModal()
  }
  handleChangeOption = (e, i) => {
    const{Options} = this.state
    Options[i].label = e.target.value
    let x = Options[i];
    x['status'] = 'ACTIVE'
    this.setState({Options})
  }
  handleChangeLabel = (e) => {
    this.setState({label:e.target.value})
    const{obj} = this.props
    obj.labelObj = e.target.value
  }
  makeInactive = (i, prop) =>{
    const{obj} = this.state
    let x = obj.additionalValues[i];
    x['status'] = prop
    this.setState({obj})
  }

  render(){
    const{obj} = this.props;
    return (
      <Modal
      show={true}
      onHide={this.props.closeModal}      
      dialogClassName="modal-100w"
      aria-labelledby="example-custom-modal-styling-title"
      centered
    >
    <Modal.Header closeButton>
    <Modal.Title id="example-custom-modal-styling-title">
      {obj.label}
    </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      { (obj.label === 'Drop Down') ? 
        <div>
          <FormControl  placeholder='Add Label' value={this.state.label} onChange={(e)=>this.handleChangeLabel(e)} />
          <i class="fas fa-plus-circle accord" onClick={this.addMoreOptions}/>
          { _.map(this.state.Options, (cx, i) => {            
              return(<p><FormControl onChange={(e)=>this.handleChangeOption(e, i)}  placeholder='Add Option'/></p>
              ) 
          })}
          <br/>
         
        {_.map(this.state.obj.additionalValues, (x, i) => {
          return(<li><span className={x.status === 'INACTIVE'? 'disabled': ''}>{x.label} </span> 
          {x.status === 'INACTIVE' ? 
          <i class="fas fa-check rightelem "onClick={()=>this.makeInactive(i, 'ACTIVE')} />
          : <i className='fas fa-times-circle rightelem' onClick={()=>this.makeInactive(i, 'INACTIVE')} /> }</li>)
        }) }
        <br/>
        <Button className='alignRight'onClick={this.handleAddValues} >Add & Save</Button>
        </div>
        :  <div>
        <InputGroup>
          <FormControl  placeholder='Add Label' value={this.state.label} onChange={(e)=>this.handleChangeLabel(e)} />
          <InputGroup.Append>
          <InputGroup.Text onClick={this.props.closeModal} className="cursorPointer">Add</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup></div>
        
      }
    </Modal.Body>
    </Modal>

    )
  }
}

export default AdditionalFields;